(function() {

	angular
		.module('ngmvac')
		.filter('completePackage', CompletePackage);

	function CompletePackage() {

		return function(arr) {
			var aux = [];
			angular.forEach(arr, function(value, index){
				if( value.complete ) {
					aux.push(value);
				}
			});

			return aux;
		}

	}

})();